/**
 * sticky-columns.js — "stick the shorter column" for the two-column product
 * layouts (gallery + info). Paired with assets/sticky-columns.css.
 *
 * Markup:
 *   <div data-sticky-columns data-sticky-top="160">
 *     <div data-sticky-col>…gallery…</div>
 *     <div data-sticky-col>…info / buy box…</div>
 *   </div>
 *
 * On desktop (min-width 769px) the shorter of the two columns gets `is-sticky`
 * and an inline `top`, so it rides along while the taller one scrolls: a short
 * gallery stays on screen while the shopper reads a long info column, and a
 * short buy box stays on screen while they browse a big gallery. If the shorter
 * column is still taller than the viewport, its *bottom* edge is pinned instead
 * (negative top) so it scrolls to its last tile and holds there rather than
 * hiding its lower half. Re-evaluated on resize and whenever either column's
 * height changes (show-more, variant image filtering, lazy app widgets).
 *
 * Below 769px nothing is applied — the layouts stack there and one of the
 * columns may be `display: contents`.
 */
(function () {
  var MQ = window.matchMedia('(min-width: 769px)');
  var BOTTOM_GAP = 24;

  function isShown(el) {
    return !!el && el.offsetParent !== null && el.offsetHeight > 0;
  }

  function setup(layout) {
    var cols = Array.prototype.filter.call(layout.children, function (el) {
      return el.hasAttribute('data-sticky-col');
    });
    if (cols.length < 2) return;
    var topOffset = parseInt(layout.getAttribute('data-sticky-top'), 10);
    if (isNaN(topOffset)) topOffset = 160;

    function clear(el) {
      el.classList.remove('is-sticky');
      el.style.top = '';
    }

    function update() {
      if (!MQ.matches) { cols.forEach(clear); return; }
      var shown = cols.filter(isShown);
      if (shown.length < 2) { cols.forEach(clear); return; }

      // Shorter column sticks; on a tie prefer the last (info / buy box).
      var shorter = shown[shown.length - 1];
      shown.forEach(function (el) { if (el.offsetHeight < shorter.offsetHeight) shorter = el; });

      shown.forEach(function (el) { if (el !== shorter) clear(el); });
      var h = shorter.offsetHeight;
      var avail = window.innerHeight - topOffset - BOTTOM_GAP;
      var top = h <= avail ? topOffset : window.innerHeight - h - BOTTOM_GAP;
      shorter.classList.add('is-sticky');
      shorter.style.top = top + 'px';
    }

    var raf = 0;
    function schedule() {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; update(); });
    }

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(schedule);
      cols.forEach(function (el) { ro.observe(el); });
    }
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
    if (MQ.addEventListener) MQ.addEventListener('change', schedule); else MQ.addListener(schedule);
    update();
  }

  function init() {
    document.querySelectorAll('[data-sticky-columns]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
